import { InjectionToken } from "@angular/core";
import { AppResolver } from "./app.resolver";
import { Resolve } from "@angular/router";
import { IApp } from "../../../../models/application/i-app";
import { IPage } from "@zaeper/communication-lib";

export const appPageResolverInjectionToken: InjectionToken<Resolve<IPage<IApp>>> = new InjectionToken<Resolve<IPage<IApp>>>("digital-signage-developer-dashboard.AppPageResolver");
